export const APP_CONFIG_DEFAULTS = {
    agentName: 'zalena-agent',
    webWidgetId: 'wgt_26808f2145e440e0',
    supportsChatInput: true,
    supportsVideoInput: false,
    supportsScreenShare: false,
    isPreConnectBufferEnabled: true,
};
